import { validateOpsDashboardSearch } from '@ops/widgets/operations-dashboard';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

export const operationsDashboardRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'operations/dashboard',
  component: lazyRouteComponent(() =>
    import('@ops-dash/pages/operations-dashboard').then((m) => ({
      default: m.OperationsDashboardPage,
    }))
  ),
});

// Operations Dashboard v2 (XT-225) — the ops-agent landing/work page. A distinct
// route from the legacy KPI dashboard above; homed in the operations domain.
export const operationsDashboardV2Route = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'operations/dashboard-v2',
  component: lazyRouteComponent(() =>
    import('@ops/pages/operations-dashboard').then((m) => ({
      default: m.OperationsDashboardPage,
    }))
  ),
  validateSearch: (input: Record<string, unknown>) =>
    validateOpsDashboardSearch(input),
});
